import { Modal } from 'antd'
import { formatCurrency } from '../../utils/string-utils'
import { formatDate } from '../../utils/entity-utils'
import {mapGroupCode, mapServiceCode, mapSourceProviders} from "../../assets/constants/constants";

type FieldModalView = {
    modalView: { data: any | null, isOpen: boolean }
    setModalView: Function
}

export default function ViewPackagesSponsor({ modalView, setModalView }: FieldModalView) {
    return (
        <Modal
            title='Chi tiết gói cước'
            open={modalView.isOpen}
            footer={[]}
            onCancel={() => setModalView({ data: null, isOpen: false })}
            width={800}
            centered
        >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <p><b>Tên gói: </b>{modalView.data?.name}</p>
                    <p><b>Phạm vi: </b>{modalView.data?.scope}</p>
                    <p><b>Thời gian tạo: </b>{formatDate(modalView.data?.CreatedAt)}</p>
                </div>
                <div>
                    <p><b>Mã gói: </b>{modalView.data?.dataPack}</p>
                    <p><b>Loại: </b>{modalView.data?.type}</p>
                    <p><b>Cập nhật: </b>{formatDate(modalView.data?.UpdatedAt)}</p>
                </div>
                <div>
                    <p><b>Nguồn: </b>{modalView.data?.source}</p>
                    <p><b>Giá gốc: </b>{formatCurrency(modalView.data?.priceUnit)}</p>
                    <p><b>Trạng thái: </b>{modalView.data?.status}</p>
                </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
                <span><b>Mô tả: </b>{modalView.data?.description}</span>
            </div>


            {/* Display Metadata/Providers */}
            {modalView.data?.metadata && modalView.data.metadata.length > 0 && (
                <>
                    <p><b>Thông tin nhà cung cấp</b></p>
                    <div>
                        {modalView.data.metadata.map((meta: any, index: number) => (
                            <div key={index} style={{
                                border: '1px solid #d9d9d9',
                                padding: '12px 16px',
                                marginBottom: '12px',
                                borderRadius: '8px',
                                backgroundColor: '#fafafa'
                            }}>
                                <div style={{ marginBottom: '8px' }}>
                                    <b>Nhà cung cấp {index + 1}: </b>{meta.provider ? mapSourceProviders[meta.provider] : 'N/A'}
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
                                    <div>
                                        <b>Dịch vụ: </b>{mapServiceCode[meta.service_code]|| 'N/A'}
                                    </div>
                                    <div>
                                        <b>Giá gốc: </b>{formatCurrency(meta.original_price || 0)}
                                    </div>
                                    <div>
                                        <b>Giá chiết khấu: </b>{formatCurrency(meta.discount_amount || 0)}
                                    </div>
                                    <div>
                                        <b>Giá bán: </b>{formatCurrency(meta.net_price || 0)}
                                    </div>
                                    <div>
                                        <b>Nhóm: </b>{mapGroupCode[meta.group_code] || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </Modal>
    )
}
